import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bd54209"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ha-signup-profile l-container" }
const _hoisted_2 = { class: "ha__ttl c-ttl" }
const _hoisted_3 = { class: "ha__sec ha-signup-profile__sec" }
const _hoisted_4 = { class: "p-signup-profile__field-container" }
const _hoisted_5 = { class: "p-messages" }
const _hoisted_6 = { class: "p-errors" }
const _hoisted_7 = { class: "c-error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", null, _toDisplayString(_ctx.infoMsgRef), 1)
        ], 512), [
          [_vShow, _ctx.infoMsgRef]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.errorMsgRef), 1)
        ], 512), [
          [_vShow, _ctx.errorMsgRef]
        ]),
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}